import { useState } from 'react';

/**
 * What to do with a scratch canvas: keep it as a nook under a name, put it
 * away, or leave it as it is.
 */
export function ScratchClear({
  onSave,
  onClear,
  onCancel,
}: {
  onSave: (name: string) => void;
  onClear: () => void;
  onCancel: () => void;
}) {
  const [name, setName] = useState('');
  const canSave = name.trim() !== '';
  const save = () => canSave && onSave(name.trim());

  return (
    <div className="palette-scrim" onPointerDown={onCancel}>
      <div
        className="palette"
        role="dialog"
        aria-label="Clear the scratch canvas"
        onPointerDown={(e) => e.stopPropagation()}
        onKeyDown={(e) => {
          if (e.key === 'Escape') onCancel();
        }}
      >
        <div className="palette-field">
          <input
            autoFocus
            aria-label="Name"
            value={name}
            placeholder="Name it to keep it"
            onChange={(e) => setName(e.target.value.replace(/\n/g, ' '))}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                save();
              }
            }}
          />
        </div>
        <div className="palette-body">
          <p className="palette-none">
            Clear puts this canvas away, with everything on it as it was; the next thing sent to scratch
            starts a new one. Save keeps it as a nook of its own under the name above.
          </p>
        </div>
        <div className="palette-foot palette-draft-foot">
          <button type="button" className="icon-btn" onClick={onCancel}>
            Cancel
          </button>
          <button type="button" className="icon-btn" onClick={onClear}>
            Clear
          </button>
          <button type="button" className="btn-primary" disabled={!canSave} onClick={save}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
